import ChartV1 from './ChartV1';
import ChartV3 from './ChartV3';
import ChartV4 from './ChartV4';

export default { ChartV1, ChartV3, ChartV4 };
